exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#dashboard-aggregate-reports-view .notice-label{margin-top:-15px}", ""]);

